export const isSelected = name => {
  if (typeof window !== 'undefined' && window) {
    return window.location.pathname.indexOf(name) > 0;
  }
  return false;
};

export default isSelected;
